const normalizeValue = (value) => {
  if (value === undefined || value === null || value === "") return null;
  if (Array.isArray(value)) {
    return value.map(normalizeValue);
  }
  return value;
};

const areValuesEqual = (original, current) => {
  return (
    JSON.stringify(normalizeValue(original)) ===
    JSON.stringify(normalizeValue(current))
  );
};

export const getChangedFields = (original = {}, current = {}, options = {}) => {
  const { exclude = [], keys } = options;
  const fieldsToCompare = keys || Object.keys(current);
  const changes = {};

  fieldsToCompare.forEach((key) => {
    if (exclude.includes(key)) return;

    const originalValue = original[key];
    const currentValue = current[key];

    if (!areValuesEqual(originalValue, currentValue)) {
      changes[key] = currentValue;
    }
  });

  return changes;
};

export const pickFields = (data = {}, keys = []) => {
  return keys.reduce((result, key) => {
    result[key] = data[key];
    return result;
  }, {});
};
